import { Link } from "react-router-dom";
import type { VenueDetail } from "../../../mocks/allVenues";

interface MapVenueCardProps {
  venue: VenueDetail;
  isSelected: boolean;
  onClick: () => void;
}

export default function MapVenueCard({ venue, isSelected, onClick }: MapVenueCardProps) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left flex gap-3 p-3 rounded-xl transition-all cursor-pointer border ${
        isSelected
          ? "bg-forest-50 border-forest-400 shadow-sm"
          : "bg-white border-stone-100 hover:border-stone-300 hover:bg-stone-50"
      }`}
    >
      {/* Image */}
      <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={venue.image}
          alt={venue.name}
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-1 mb-0.5">
          <span className="text-sm font-semibold text-anthracite-800 leading-tight truncate">{venue.name}</span>
          {isSelected && (
            <div className="w-4 h-4 flex-shrink-0 flex items-center justify-center">
              <i className="ri-map-pin-2-fill text-forest-600 text-sm" />
            </div>
          )}
        </div>

        <div className="flex items-center gap-1 mb-1">
          <i className="ri-star-fill text-amber-400 text-xs" />
          <span className="text-xs font-semibold text-anthracite-700">{venue.rating}</span>
          <span className="text-xs text-stone-400">({venue.reviews.toLocaleString()})</span>
        </div>

        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-xs text-stone-500 truncate">{venue.district}</span>
          <span className="text-stone-300">·</span>
          <span className="text-xs text-stone-500">{venue.distanceKm} km</span>
          {venue.isEditorPick && (
            <>
              <span className="text-stone-300">·</span>
              <span className="text-xs text-amber-600 font-medium whitespace-nowrap">Editör</span>
            </>
          )}
          {!venue.isOpen && (
            <span className="text-xs text-red-400 whitespace-nowrap">Kapalı</span>
          )}
        </div>
      </div>
    </button>
  );
}
